// React and dependencies imports
import React, { Component } from "react";
import { Route, Switch } from "react-router"; // react-router v4
import { ConnectedRouter } from "connected-react-router";
import { history } from "./store";
// Component imports
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
// Home
import Home from "./pages/Home";
// Ship
import Ship from "./pages/Ship";
import Rates from "./pages/ship/Rates";
import Products from "./pages/ship/Products";
import NFG from "./pages/ship/Products/NFG";
import SouthwestStandard from "./pages/ship/Products/SouthwestStandard";
import FreshFast from "./pages/ship/Products/FreshFast";
import GuidelinesAndTools from "./pages/ship/GuidelinesAndTools";
import Packaging from "./pages/ship/GuidelinesAndTools/Packaging";
import InternationalCustomsAndGuidelines from "./pages/ship/GuidelinesAndTools/InternationalCustomsAndGuidelines";
import CargoBinCapacities from "./pages/ship/GuidelinesAndTools/CargoBinCapacities";
import ContentRestrictions from "./pages/ship/GuidelinesAndTools/ContentRestrictions";
import ChargesAndPayments from "./pages/ChargesAndPayments";
import Book from "./pages/Book";
import RequestAirWaybillNumbers from "./pages/ship/RequestAirWaybillNumbers";
import billingAndInvoicingForm from "./pages/manage/FormsAndApplications/BillingAndInvoicingForm";
import AccountApplicationForm from "./pages/ship/StartShipping/AccountApplicationForm";
import FlightSchedules from "./pages/ship/FlightSchedules/FlightSchedules";
import FlightSchedulesResults from "./pages/ship/FlightSchedules/FlightSchedulesResults";
import InterlineDestinations from "./pages/ship/Facilities/InterlineDestinations";
import Facilities from "./pages/ship/Facilities";
import FacilityDetails from "./components/FacilityDetails/FacilityDetails";
import ShippingAdvisory from "./pages/ship/ShippingAdvisory";
import ShippingAdvisoryItem from "./pages/ship/ShippingAdvisoryItem";
import FacilitiesAll from "./components/FacilitiesAll/FacilitiesAll";
// Manage
import Manage from "./pages/Manage";
import FormsAndApplications from "./pages/manage/FormsAndApplications";
import FileAClaim from "./pages/manage/FileAClaim";
import ManageTrackingResults from "./pages/manage/ManageTrackingResults";
import UpdateAccountForm from "./pages/manage/FormsAndApplications/UpdateAccountForm";
import AdditionalLocationRequestForm from "./pages/manage/AdditionalLocationRequestForm";
import EmailPreferenceForm from "./pages/manage/FormsAndApplications/EmailPreferenceForm";
import ServiceFailureForm from "./pages/manage/FileAClaim/ServiceFailureForm";
import LostOrDamagedClaimForm from "./pages/manage/FileAClaim/LostOrDamagedClaimForm";
import OnlineBookingForm from "./pages/manage/FormsAndApplications/OnlineBookingForm";
import TrackingDetails from "./pages/manage/TrackingDetails";
import ScanDetails from "./pages/manage/ScanDetails";
import ManageTracking from "./pages/manage/ManageTracking";
// Learn
import Learn from "./pages/Learn";
import SpecialtyShipments from "./pages/learn/SpecialtyShipments";
import LifeSciences from "./pages/learn/specialty-shipments/LifeSciences";
import Perishables from "./pages/learn/specialty-shipments/Perishables";
import HumanRemains from "./pages/learn/HumanRemains";
import HowToShip from "./pages/learn/HowToShip";
import FAQ from "./pages/learn/FAQ";
import DeclaredValue from "./pages/learn/DeclaredValue";
// About
import About from "./pages/About";
import News from "./pages/About/News";
import NewsItem from "./pages/About/NewsItem";
import Awards from "./pages/About/Awards";
import AwardItem from "./pages/About/AwardItem";
import PressReleases from "./pages/About/PressReleases";
import PressReleaseItem from "./pages/About/PressReleaseItem";
import CustomerTestimonials from "./pages/About/CustomerTestimonials";
import CustomerTestimonialItem from "./pages/About/CustomerTestimonialItem";
import OurStory from "./pages/About/OurStory";
import NeedAssistance from "./pages/About/NeedAssistance";
// Contact
import Contact from "./pages/Contact";
import SearchResults from "./pages/SearchResults";
// Others
import FormAssemblyPatterns from "./pages/FormAssemblyPatterns";
import TrainingVideos from "./pages/TrainingVideos";
import Confirmation from "./pages/Confirmation";
import TermsAndConditions from "./pages/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import BlankComponent from "./components/BlankComponent/BlankComponent";
import Sitemap from "./pages/Sitemap";
import NotFound from "./pages/NotFound";
import AnalyticsComponent from "./components/AnalyticsComponent/AnalyticsComponent";

// Routes

/**
 * Externalize routes for the forms, to reuse them
 * in other parts of the codebase
 */
const contactFormUrl = "/contact";
const requestAirWaybillNumberFormUrl = "/ship/request-air-waybill-numbers/";
const accountApplicationFormUrl = "/ship/apply/";
const updateAccountFormUrl = "/manage/forms-and-applications/update-account-form/";
const additionalLocationRequestFormUrl = "/manage/additional-location-request-form/";
const emailReferenceFormUrl = "/manage/forms-and-applications/email-preference-form/";
const serviceFailureFormUrl = "/manage/file-a-claim/service-failure-form/";
const lostOrDamagedClaimFormUrl = "/manage/file-a-claim/lost-or-damaged-claim-form/";
const onlineBookingFormUrl = "https://hangara.webflow.io/swa-cargo-booking";

const billingAndInvoicingFormUrl = "/manage/forms-and-applications/billing-and-invoicing-form/";

const rapidRewardsFormUrl =" global.config.rapidRewardsFAQUrl";

class Main extends Component {
    render() {
        return (
            <ConnectedRouter history={history}>
                <AnalyticsComponent>
                    <ScrollToTop>
                        <BlankComponent>
                            <Header />
                            <Switch>
                                {/* Home */}
                                <Route path="/" exact component={Home} />
                                <Route path="/privacy-policy" component={PrivacyPolicy} />
                                <Route path="/terms-and-conditions" component={TermsAndConditions} />
                                <Route path="/training" component={TrainingVideos} />
                                <Route path="/shipping-advisory" exact component={ShippingAdvisory} />
                                <Route path="/shipping-advisory/advisory-item" exact component={ShippingAdvisoryItem} />
                                <Route path="/sitemap" exact component={Sitemap} />

                                {/* Ship */}
                                <Route path="/ship/" exact component={Ship} />
                                <Route path="/ship/rates" exact component={Rates}/>
                                <Route path="/ship/products" exact component={Products} />
                                <Route path="/ship/products/nfg" exact component={NFG} />
                                <Route path="/ship/products/southweststandard" exact component={SouthwestStandard} />
                                <Route path="/ship/products/freshfast" exact component={FreshFast} />
                                <Route path="/ship/guidelines-and-tools" exact component={GuidelinesAndTools} />
                                <Route path="/ship/guidelines-and-tools/packaging" exact component={Packaging} />
                                <Route path="/ship/guidelines-and-tools/cargo-bin-capacities" exact component={CargoBinCapacities} />
                                <Route path="/ship/guidelines-and-tools/content-restrictions" exact component={ContentRestrictions} />
                                <Route path="/ship/guidelines-and-tools/international-customs-and-guidelines" exact component={InternationalCustomsAndGuidelines} />
                                <Route path="/ship/charges-and-payments/" exact component={ChargesAndPayments} />
                                <Route path="/ship/book/" exact component={Book} />
                                <Route path={requestAirWaybillNumberFormUrl} exact component={RequestAirWaybillNumbers} />
                                <Route path={accountApplicationFormUrl} exact component={AccountApplicationForm} />
                                <Route path="/ship/flight-schedules/" exact component={FlightSchedules} />
                                <Route path="/ship/flight-schedules/results/" exact component={FlightSchedulesResults} />
                                <Route path="/ship/facilities/" exact component={Facilities} />
                                <Route path="/ship/facilities/facility" exact component={FacilityDetails} />
                                <Route path="/ship/facilities/interline-destinations/" exact component={InterlineDestinations} />
                                <Route path="/ship/facilities/allFacilities" exact component={FacilitiesAll} />

                                {/* Manage */}
                                <Route path="/manage/" exact component={Manage} />
                                <Route path="/manage/forms-and-applications" exact component={FormsAndApplications} />
                                <Route path="/manage/file-a-claim" exact component={FileAClaim} />
                                <Route path="/tracking-results/" exact component={ManageTrackingResults} />
                                <Route path="/manage/tracking/tracking-results/" exact component={ManageTrackingResults} />
                                <Route path={billingAndInvoicingFormUrl} exact component={billingAndInvoicingForm} />
                                <Route path={additionalLocationRequestFormUrl} exact component={AdditionalLocationRequestForm} />
                                <Route path={updateAccountFormUrl} exact component={UpdateAccountForm} />
                                <Route path={emailReferenceFormUrl} exact component={EmailPreferenceForm} />
                                <Route path={serviceFailureFormUrl} exact component={ServiceFailureForm} />
                                <Route path={lostOrDamagedClaimFormUrl} exact component={LostOrDamagedClaimForm} />
                                <Route path={onlineBookingFormUrl} exact component={OnlineBookingForm} />
                                <Route path="/tracking-details" exact component={TrackingDetails} />
                                <Route path="/tracking-results/tracking-details" exact component={TrackingDetails} />
                                <Route path="/manage/tracking/tracking-details" exact component={TrackingDetails} />
                                <Route path="/manage/tracking/tracking-results/tracking-details" exact component={TrackingDetails} />
                                <Route path="/scan-details" exact component={ScanDetails} />
                                <Route path="/tracking-details/scan-details" exact component={ScanDetails} />
                                <Route path="/manage/tracking" exact component={ManageTracking} />

                                {/* Learn */}
                                <Route path="/learn/" exact component={Learn} />
                                <Route path="/learn/specialty-shipments" exact component={SpecialtyShipments} />
                                <Route path="/learn/specialty-shipments/life-sciences" exact component={LifeSciences} />
                                <Route path="/learn/specialty-shipments/perishables" exact component={Perishables} />
                                <Route path="/learn/specialty-shipments/human-remains" exact component={HumanRemains} />
                                <Route path="/learn/how-to-ship/" exact component={HowToShip} />
                                <Route path="/learn/faq" exact component={FAQ} />
                                <Route path="/learn/declared-value" exact component={DeclaredValue} />

                                {/* About */}
                                <Route path="/about/" exact component={About} />
                                <Route path="/about/customer-testimonials" exact component={CustomerTestimonials} />
                                <Route path="/about/customer-testimonials/customer-testimonial" exact component={CustomerTestimonialItem} />
                                <Route path="/about/news" exact component={News} />
                                <Route path="/about/news/news-item" exact component={NewsItem} />
                                <Route path="/about/awards" exact component={Awards} />
                                <Route path="/about/awards/award" exact component={AwardItem} />
                                <Route path="/about/press-releases" exact component={PressReleases} />
                                <Route path="/about/press-releases/press-release" exact component={PressReleaseItem} />
                                <Route path="/about/our-story" exact component={OurStory} />
                                <Route path="/about/contact-the-care-center" exact component={NeedAssistance} />

                                {/* Contact */}
                                <Route path={contactFormUrl} exact component={Contact} />

                                {/* Other */}
                                <Route path="/form-assembly-patterns/" exact component={FormAssemblyPatterns} />
                                <Route path="/confirmation/" exact component={Confirmation} />
                                <Route path="/search-results" exact component={SearchResults} />

                                <Route component={NotFound} />
                            </Switch>
                            <Footer />
                        </BlankComponent>
                    </ScrollToTop>
                </AnalyticsComponent>
            </ConnectedRouter>
        );
    }
}

export default Main;

export {
    contactFormUrl,
    requestAirWaybillNumberFormUrl,
    accountApplicationFormUrl,
    updateAccountFormUrl,
    additionalLocationRequestFormUrl,
    emailReferenceFormUrl,
    serviceFailureFormUrl,
    lostOrDamagedClaimFormUrl,
    onlineBookingFormUrl,
    rapidRewardsFormUrl,
    billingAndInvoicingFormUrl
};



// WEBPACK FOOTER //
// ./src/Main.js